import axios from "axios";
import {useParams} from 'react-router-dom';
import {useEffect, useState} from "react";
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function IpPayment() {
    const [opData, setopData] = useState([]);
    const [amount, setAmount] = useState(0);
    const [iptotData, setIptotData] = useState([]);
    const [balance, setBalance] = useState(0);
    const [trans, setTrans] = useState('');
    const {ip_id, id} = useParams();
    useEffect(() => {
        try {
            axios.get(baseUrl + 'ip-pay/' + ip_id + '/' + id + '/')
                .then(function (response) {
                    setopData(response.data);
                    setAmount(response.data[0].advance);
                    setBalance(0);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        fetchtotData();
    }, []);
    function fetchtotData() {
        axios.get(baseUrl + "view-ip-tot/" + ip_id)
            .then(response => {
                setIptotData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleAmountChange = (event) => {
        let newAmount = parseInt(event.target.value, 10);
        const maxAmount = opData[0].advance;
        if (newAmount > maxAmount) {
            newAmount = maxAmount;
        }
        setAmount(newAmount);
        setBalance(maxAmount - newAmount);
    };
    const handlePaymentTypeChange = (event) => {
        const value = event.target.value;
        if (value === 'creditpay') {
            setAmount(0);
            setBalance(opData[0].advance);
        } else {
            setAmount(opData[0].advance);
            setBalance(0);
        }
    }
    const handleFormSubmit = (e) => {
        e.preventDefault();
        const dbType = document.getElementById('dbType').value;
        axios.post(`${baseUrl}get_sale_ip/`)
            .then(response => {
                const sale_ip = response.data.value;
                const _formData = new FormData();
                _formData.append('paid', amount);
                _formData.append('balance', balance);
                _formData.append('invoice', sale_ip);
                _formData.append('mode', dbType);
                _formData.append('trans_detail', trans);
                _formData.append('cashier', userName);
                _formData.append('status', '2');
                axios.post(baseUrl + 'ip-payment/' + id + '/', _formData, {
                    headers: {
                        'content-type': 'multiple/form-data'
                    }
                })
                    .then(response => {
                        if (response.status == 200 || response.status == 201) {
                            const tot_invoiced = parseFloat(iptotData[0][0].tot_invoiced) + parseFloat(opData[0].advance);
                            const tot_paid = parseFloat(iptotData[0][0].tot_paid) + parseFloat(amount);
                            const tot_balance = parseFloat(iptotData[0][0].tot_balance) + parseFloat(balance);
                            const remain_balance = parseFloat(iptotData[0][0].remain_balance) + parseFloat(amount);
                            const IpId = iptotData[0][0].id;
                            _formData.append('tot_invoiced', tot_invoiced.toFixed(2));
                            _formData.append('tot_paid', tot_paid.toFixed(2));
                            _formData.append('tot_balance', tot_balance.toFixed(2));
                            _formData.append('remain_balance', remain_balance.toFixed(2));
                            _formData.append('addedby', userName);
                            _formData.append('ip_add', ipAddress);
                            _formData.append('location', userLocation);
                            axios.put(`${baseUrl}update-ip-tot/${IpId}/`, _formData)
                                .then(response => {
                                    Swal.fire({
                                        title: 'Payment Success and Invoice is Generated',
                                        icon: 'success',
                                        timer: 2000,
                                        showConfirmButton: false
                                    })
                                });
                            setTimeout(() => {
                                window.location.href = '/ip-invoice/' + sale_ip + '/';
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        Swal.fire(
                            'Error!',
                            'Failed to add inv entry. Please try again later.',
                            'error'
                        );
                    });
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to generate unique value. Please try again later.',
                    'error'
                );
            });
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className="row">
                        <h3 className="text-center"> IP Payment</h3>
                        <div className="table-responsive">
                            <table className="erp-table-modern">
                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th>IP Id</th>
                                    <th>Patient Id</th>
                                    <th>Patient Name</th>
                                    <th>Addedby</th>
                                    <th>Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                {opData.map((row, index) =>
                                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                        <td>{ip_id}</td>
                                        <td>{row.ip.pat.pat_id}</td>
                                        <td>{row.ip.pat.patient}</td>
                                        <td>{row.addedby}</td>
                                        <td>{row.advance}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                            <div className="d-flex justify-content-center">
                                <form style={{width: '500px'}}>
                                    <label>Choose Payment Type</label>
                                    <select name="dbType" id="dbType" onChange={handlePaymentTypeChange}>
                                        <option value="cash">Cash</option>
                                        <option value="card">Card</option>
                                        <option value="UPI">UPI</option>
                                    </select>
                                    <div className="form-group mt-3">
                                        <label style={{fontWeight: 'bold'}}>Amount: &nbsp;</label>
                                        <div className="input-group">
                                            <div className="input-group-addon me-2 ">&#8377;</div>
                                            <input type="number" name="amount" id="amount" value={amount}
                                                   onChange={handleAmountChange} max={amount}/>
                                        </div>
                                    </div>
                                    <div className="form-group mt-3">
                                        <label style={{fontWeight: 'bold'}}>Balance Amount: &nbsp;</label>
                                        <div className="input-group">
                                            <div className="input-group-addon me-2 ">&#8377;</div>
                                            <input type="number" name="balance" id="balance" value={balance}
                                                   onChange={handleAmountChange} readOnly/>
                                        </div>
                                    </div>
                                    <div className="form-group mt-3">
                                        <label style={{fontWeight: 'bold'}}>Reason: &nbsp;</label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                name="trans"
                                                id="trans"
                                                value={trans}
                                                onChange={(e) => setTrans(e.target.value)}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <button type="button" onClick={handleFormSubmit} className="btn btn-primary mt-4">
                                        Submit
                                    </button>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default IpPayment;